/*
 * @Date: 2023-04-16 21:19:43
 * @LastEditors: simLarry
 * @LastEditTime: 2023-04-16 23:32:32
 * @FilePath: \F1-M1-QRP-CODE\pages\restrict.js
 */
import React from "react";

export default class Restrict extends React.Component{
    constructor(){
        super();
        this.state = {

        }
    }


    render(){
        return (
            <div className="restrict_page">
                <div className="restrict_bg">
                    <img className="restrict-web" src="/static/images/restrict/fun88-restriction.jpg" />
                    <img className="restrict-mob" src="/static/images/restrict/fun88-restriction-m.jpg" />
                </div>
                <div className="restrict_right">
                    <div className="head">
                        <img src="/static/images/restrict/icon-prohibited.png" />
                        <span>访问受限</span>
                    </div>
                    <div className="section">
                        <img className="country" src="/static/images/restrict/flag6.png" />
                        <div className="space-y">
                            <h4>Dear members,</h4>
                            <div>The page that you are trying to access has been restricted in this location. We apologize for any inconvenience that this may have caused. Should you have any inquiries, please contact our customer service centre at <span className="cs">Live Help</span></div>
                        </div>
                    </div>

                    <div className="section">
                        <img className="country" src="/static/images/restrict/flag1.png" />
                        <div className="space-y">
                            <h4>登录限制</h4>
                            <div>抱歉! 您所在地区受到限制，无法正常游览我们的网站。若有不便之处，我们深表歉意。 若您有任何疑问，请联系我们的<span className="cs">在线客服</span>或发邮件至<span className="email">cs@fun88.com</span></div>
                            <div className="illustrate">
                                <a href="https://i.youku.com/Fun88Bliss" target="_blank" className="icon">
                                    <img src="/static/images/restrict/youku.png" alt="观看乐天堂优酷视频" />
                                </a>
                                <a href="https://www.weibo.com/fun88angel?from=profile&amp;wvr=6" target="_blank" className="icon">
                                    <img src="/static/images/restrict/weibo.png" alt="请关注乐天堂微博" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="section">
                        <img className="country" src="/static/images/restrict/flag2.png" />
                        <div className="space-y">
                            <h4>การเข้าสู่ระบบถูกจำกัด</h4>
                            <div>
                                เข้าใช้งานเว็บไซต์จากตำแหน่ง พื้นที่ หรือประเทศที่ไม่ได้รับอนุญาต ขออภัยในความไม่สะดวก หากมีข้อสอบถามเพิ่มเติม กรุณาติดต่อเจ้าหน้าที่ฝ่ายบริการลูกค้า อีเมล:
                                <span className="email">cs.thai@fun88.com</span>
                            </div>
                            <div className="illustrate">
                                <a className="icon">
                                    <img src="/static/images/restrict/line.png" />
                                </a>
                                <a href="https://www.youtube.com/user/Fun88AngelsTV" target="_blank" className="icon">
                                    <img src="/static/images/restrict/youtube.png" alt="เป็นสมาชิก Fun88 บน Youtube" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="section">
                        <img className="country" src="/static/images/restrict/flag3.png" />
                        <div className="space-y">
                            <h4>Đường dẫn hạn chế</h4>
                            <div>Đường dẫn mà Quý Khách đang truy cập trên trang này bị hạn chế. Chúng tôi thành thật xin lỗi cho những bất tiện gây ra. Nếu Quý Khách có thắc mắc về vấn đề này, vui lòng liên hệ Bộ phận Chăm Sóc Khách Hàng tại Hotline (+84)2844581397 hoặc email <span className="email">cs.viet@fun88.com</span> hoặc Hỗ Trợ Trực Trợ Trực Tuyến</div>
                            <div className="illustrate">
                                <a href="https://www.facebook.com/FunSportVietNam/" target="_blank" className="icon">
                                    <img src="/static/images/restrict/fb.png" alt="Like FUN88 tại Facebook" />
                                </a>
                                <a className="icon">
                                    <img src="/static/images/restrict/zalo.png" />
                                </a>
                                <a href="https://www.youtube.com/user/Fun88AngelsTV" target="_blank" className="icon">
                                    <img src="/static/images/restrict/youtube.png" alt="Theo dõi FUN88 tại Youtube" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}